 
   
function addstyle()
{
    var iconstyle=$('#styleicon').attr('style');
  $('#styleicon').attr('href',iconstyle)
  
  
    var getstyle=$('#style').attr('style');
  $('#style').attr('href',getstyle)
  
  

}

window.onload = function() {
  
   if (window.location.href.indexOf("?getoff") > -1) {
     setTimeout(function(){
     
     $('li.parent.last').trigger('click');
     
     },2000)
    }
    $(document).on('click', 'h3.small_Menu svg.close', function() {
   console.log('test');
   $('.conjureModal').fadeOut();
 })
   $('li.parent.last').on("click", function(e) {
          e.preventDefault();
     
     
   $('.conjureModal').fadeIn();
   })
    
//   $('#mystle_css').removeAttr('disabled')
  $('#detail .internal_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  fade:true,
  autoplaySpeed: 4000,
  speed: 300,
  lazyLoad: 'ondemand',
  asNavFor: '.thumb-nav',
  prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="26" viewBox="0 0 26 26" fill="none"> <rect opacity="0.33" x="26" width="26" height="26" transform="rotate(90 26 0)" fill="url(#pattern0qwe)"/> <defs> <pattern id="pattern0qwe" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlink:href="#image0qwe" transform="scale(0.00195313)"/> </pattern> <image id="image0qwe" width="512" height="512" xlink:href="data:image/png;base64,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"/> </defs> </svg></div>',
  nextArrow: '<div class="slick-next"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <rect opacity="0.33" y="26" width="26" height="26" transform="rotate(-90 0 26)" fill="url(#pattern0456)"/> <defs> <pattern id="pattern0456" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlink:href="#image0456" transform="scale(0.00195313)"/> </pattern> <image id="image0456" width="512" height="512" xlink:href="data:image/png;base64,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"/> </defs> </svg></div>',
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        dots: true
      }
    }
    ]
});
  // Thumbnail/alternates slider for product page
 var items=$('.total_item').attr('items');
$('.thumb-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  centerPadding: '0px',
  asNavFor: '.internal_slider',
  dots: false,
  centerMode: false,
  arrows: false,
  draggable: false,
  speed:200,
  focusOnSelect: true  
});
  
//   currency converter
   setTimeout(function(){
 
    
    var showWidgetReview=$('#showWidgetReview').attr('datasrc');
  $('#showWidgetReview').attr('src',showWidgetReview)
  
  
    },6000)
 var default_curncy= $('li.currency-picker--wrapper select.currency-picker').find('option:selected').attr('value');
 $('.currency_div .active_currency').text(default_curncy);
  $('ul.all_currency li').click(function(){
  
 var that=$(this);
  
  var get_clickcurncy=that.attr('value');
    
     $('.currency_div .active_currency').text(get_clickcurncy);
    $("li.currency-picker--wrapper select.currency-picker option:selected").prop("selected", false)
    $('li.currency-picker--wrapper select.currency-picker option').each(function(){
    
   var check_val=$(this).attr('value');
      if(get_clickcurncy==check_val){
      
     $(this).prop("selected", true)
      $(this)[0].click();
      }
    
    })
   
   
  })
  
  setTimeout(test, 1000); //delay for demonstration

function test() {

  var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

  if (mac) {
    $('video#myVideo').attr('controls','controls')
  }
}
  
  
  

  $('.hero--banner').addClass('hero_active');
  setTimeout(function(){
  addstyle();
  
  },2000)
  setTimeout(function(){
    
     $('.hero--banner').addClass('new_active');
  },1000)
    
};
$(document).ready(function(){
  // Main/Product image slider for product page
  
  

  $('main#MainContent  .shopify-section:nth-child(2)').addClass('first_fixed');

  

  
  $('.add_Cart').on("click", function(e) {
    
     e.preventDefault();
    console.log('test');
    $(this).next('.add_form').find('.product-form__cart-submit').trigger('click');
  })
   $(".set > a").on("click", function(e) {
     
     e.preventDefault();
     if($(this).hasClass('video')){
     
     console.log('test');
       
       var video__id=$(this).attr('videolink');
  $('.popup--video .video--wrapper iframe').attr('src',video__id);
  
$('.popup--video').show();
  $('body').addClass('noscroll');
       
       
     
     }else{
      
    console.log('test');
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
     }
  });
  $('.close--video').click(function(){

  $('.popup--video .video--wrapper iframe').attr('src','');
  
$('.popup--video').hide();
  $('body').removeClass('noscroll');


})
  
var h3news= $('.desktop_news').find('h3').text();
  var info_newsltr= $('.desktop_news').find('.info_newsltr').html();
  
  $('.newletter_parent.desktop_hide').find('h3').text(h3news);
  $('.newletter_parent.desktop_hide').find('.info_newsltr').html(info_newsltr);
  
  var foot_log=$('.header_logos .logo img').attr('data-src');
  $('.footer_logo.footer_disp img.fot_log').attr('data-src',foot_log)
  $('.footer_logo.footer_disp img.fot_log').addClass('lazyload ')
  
$('.mob_menu.desktop_hide li').click(function(){
  
  
//   $('.hamburger-menu.desktop_hide .menu__btn').trigger('click');
  
    })


  $('.hamburger-menu.desktop_hide #menu__toggle').change(function(){
  
  
 $('body').toggleClass('menu_hum');

  
})
  $('.cart_parent').click(function(){
  
  window.location.href='/cart'
  })
$(".regular_btn").hover(
    function(e){
    $(this).addClass('active');
    
    }, // over
    function(e){
    $(this).removeClass('active');
    }  // out
);
  
$('p.reset_form').click(function(){
$('.contact_form_flex .flex input').val('');
  $('.contact_form_flex textarea').val('');


})
var width=$(window).width();
  if(width<1080){
  
//   currency converter
   setTimeout(function(){
 
   $('.hero--banner').css('background-image','url("https://cdn.shopify.com/s/files/1/1911/9995/files/hero-home-img-mobile_1_-min_1.jpg?v=1633548462")')
     $('.hero--banner').addClass('active');
     
    },3000)
    $('.product-images.demo-gallery').addClass('lod');
   $('.featured_custom_product .left_side_img ').removeAttr('id');
$('.news_grid.other_pages .flex').slick({
          dots: false,
  arrows:false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          dots:true
        });
   
  }else{
    
    
    $('.featured_custom_product .desktop_hide').removeAttr('id'); 
  }
  
  $(".all_menu li.parent ").hover(
    function(e){
    $(this).addClass('add_active');
    
    }, // over
    function(e){
    $(this).removeClass('add_active');
    }  // out
);
  
  
  
  
  if($('ul.custom--variations')){
$('ul.custom--variations li').click(function(){
  $('ul.custom--variations li').removeClass('active');
var that=$(this);
var vantImg=that.attr('vairant--img');
  that.addClass('active');
var numbering= that.attr('numbering');
  $('.thumb-nav li').each(function(){
  var thatigs=$(this)
  var vrnt=thatigs.attr('vrnt');
    if(vrnt==vantImg){
    
    thatigs.get(0).click();
    }
  
  })
 
 $('select.variant--slct.product-form__variants.hide.no-js').prop("selected", false);
  $('select.variant--slct.product-form__variants.hide.no-js option').each(function(){
  var thats=$(this)
  var numbering2=thats.attr('numbering');
    
    
   
    if(numbering==numbering2){
     
   thats.prop('selected', true);
      
     
    }
  
  })
  var sold=$('select.variant--slct.product-form__variants.hide.no-js option:selected').attr('sold'); 
  if(sold=='soldout'){
  
$('button.regular_btn.btn.product-form__cart-submit').addClass('soldout')
  }else{
  
  $('button.regular_btn.btn.product-form__cart-submit').removeClass('soldout')
  }

})
setTimeout(function(){

   var sold=$('select.variant--slct.product-form__variants.hide.no-js option:selected').attr('sold'); 
  if(sold=='soldout'){
  
$('button.regular_btn.btn.product-form__cart-submit').addClass('soldout')
  }else{
  
  $('button.regular_btn.btn.product-form__cart-submit').removeClass('soldout')
  }
  
  },1000)
  }
  $('.product_btn a.regular_btn').click(function(event){
 var cns=$(this).find("select").find(":selected").val();
  
 event.preventDefault();
  addItemToCart(cns)
  
  })
    function addItemToCart(variant_id) {
    data = {
      "id": variant_id,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/checkout'; 
      }
    });
    window.location = '/checkout';
  }
  
  
  
  
})






$(function(){
  $(window).scroll(function(){
//     if($('body.template-page').hasClass('contact')){
    
    
//      var get_val=$('header').offset().top - $('.contact_section .text-grid-conact').offset().top
//        if(get_val>-103){
//     $('header').addClass('solid');
    
//     }else{
//      $('header').removeClass('solid');
    
//     }
     
     
    
//     }else{
//     var get_val=$('header').offset().top - $('.shopify-section.first_fixed').offset().top
//     if(get_val>-269){
//     $('header').addClass('solid');
    
//     }else{
//      $('header').removeClass('solid');
    
//     }
//      }
  })
 
})
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
  
 
  
  if($('section.featured_img_single .bottom_img').length){
  $('section.featured_img_single .bottom_img img').each(function() {
      var activeState = $('section.featured_img_single .bottom_img');
    if ($(this).isInViewport()) {
     activeState.addClass('actve');
    } else {
      activeState.removeClass('actve');
    }
  });
  
  } 
  

   var best=$('.all-bst-products');
  if(best.length){
  if (best.isInViewport()) {
     if(best.hasClass('active')){}else{
        best.addClass('active');
        $('.product_loopimg').each(function(){
   
     
    
  var oldsrc=$(this).attr('new-data-src');
    $(this).attr('data-src',oldsrc);
     $(this).addClass('lazyload');
    
  
  })
        
       
     }
  }
  }
   var vido=$('.featured_video');
   if(vido.length){
   if (vido.isInViewport()) {
     if(vido.hasClass('active')){}else{
       vido.addClass('active');
     var video_src=$('video#myVideo').attr('video_src');
 $('video#myVideo').html('<source type="video/mp4" src="'+video_src+'">')
     
     }
   }
  
   }  
  
    var four=$('#foursixty-hideable-container');
    if(four.length){
   var fournnew=$('.instrgram_section--product');
   if (fournnew.isInViewport()) {
     if(fournnew.hasClass('active')){}else{
       fournnew.addClass('active');
    
 var data__src=fournnew.find('script').attr('data-src');
     fournnew.find('script').attr('src',data__src);
     }
   }
  
    }
});


// hover on image start



// var rect = $('.animated_img')[0].getBoundingClientRect();
// var mouse = {x: 0, y: 0, moved: false};

// $(".animated_img").mousemove(function(e) {
//   mouse.moved = true;
//   mouse.x = e.clientX - rect.left;
//   mouse.y = e.clientY - rect.top;
// });
 
// // Ticker event will be called on every frame
// TweenLite.ticker.addEventListener('tick', function(){
//   if (mouse.moved){    
//     parallaxIt(".coordinates_all", -400);
//     parallaxIt(".animated_img img", -40);
//   }
//   mouse.moved = false;
// });

// function parallaxIt(target, movement) {
//   TweenMax.to(target, 0.5, {
//     x: (mouse.x - rect.width / 2) / rect.width * movement,
//     y: (mouse.y - rect.height / 2) / rect.height * movement
//   });
// }

// $(window).on('resize scroll', function(){
//   rect = $('.animated_img')[0].getBoundingClientRect();
// })


// hover on image start





// Cache selectors
var lastId,
    topMenu = $(".all_menu.mobile_hide ul"),
    topMenuHeight = topMenu.outerHeight()+15,
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function(e){
  var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
  $('html, body').stop().animate({ 
      scrollTop: offsetTop
  }, 300);
  e.preventDefault();
});

$(document).ready(function(){


 if($('body').hasClass('template-article')){
console.log('yesss');

var hrf=$('.artile_next a').attr('href');
  console.log(hrf);
   jQuery.ajax({
      type: 'GET',
      url: hrf,
     
      success: function(data) { 
        
   var getdata=$(data).find('.collection-page').attr('data-background-image-url');
      
        $('.artile_next').css('background-image', 'url(' + getdata + ')');
      }
    });

}

  });